// import { getStates as getPartsOrderStates } from "emun.order/parts/parts-order.states";
import isFunction from "lodash/isFunction";
import custList from "emun.cust/list/cust-list.htm";
import views from "emun.cust/details/cust-details.states";

export default ({
  mode = "cust",
  menu,
  base = menu ? `${menu}.${mode}` : mode,
  nav = 1,
  title = "Customers (beta)",
  icon = "handshake-o",
  url = `/${mode}`,
  breadcrumbs = false,
  pageHeader = false,
} = {}) => {
  const states = {
    [base]: {
      url,
      menu,
      nav,
      icon,
      title,
      breadcrumbs,
      pageHeader,
      resolve: {
        // proxy: ($window) =>
        //   this.isProxy && $window.location.replace(`${this.baseUrl}#/cust`),
      },
      rerouteTo: `${base}.list`,
      templateProvider: ($stateParams) => `<cust-container />`,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      title: "List",
      templateUrl: custList,
    },
    [`${base}.profile`]: {
      menu: base,
      title: `Customer Details`,
      url: `/my-profile`,
      onEnter($state, $session) {
        $state.go(`${base}.details`, { customerId: $session.retailerId });
      },
    },
    [`${base}.details`]: {
      menu: base,
      url: `/{customerId:[^/]+}`,
      title: `Customer Details`,
      hidePageHeader: true,
      rerouteTo: Object.keys(views).map((sub) => `${base}.details.${sub}`)[0],
      templateProvider: ($stateParams) =>
        `<cust-details customer-id="${$stateParams.customerId}" />`,
    },
  };

  for (let sub in views) {
    if (isFunction(views[sub])) {
      const subStates = views[sub]({
        menu: `${base}.details`,
      });
      // console.debug("Customer subStates", sub, subStates);
      Object.assign(states, subStates);
    } else {
      states[`${base}.details.${sub}`] = {
        nav,
        breadcrumbs: false,
        pageHeader: false,
        menu: `${base}.details`,
        url: "/" + sub,
        ...views[sub],
      };
    }
  }

  // console.debug("Customer States", states);
  return states;
};
